export const encodeCookiePreferences = (cookiePreferences) => {
    return btoa(JSON.stringify(cookiePreferences));
};
//# sourceMappingURL=encodeCookiePreferences.js.map